import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as VirtualConnectionTableDownstreamOwnersQuery
export const VirtualConnectionTableDownstreamOwnerIdsQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamOwnerIdsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
